<template>
  <div class="page-view">
    <!-- 整体区域 -->
    <div class="section-wrapper">
      <!-- 标题 start -->
      <div class="content-title">新增进出区域分析任务</div>
      <!-- 标题 end -->

      <!-- 内容部分 start -->
      <div class="content-section">
        <!-- 内容操作 -->
        <div class="wrapper">
          <!-- 左侧部分 -->
          <div class="wrapper-left">
            <!-- 任务ID -->
            <div class="item task-code">
              <span class="item-title">任务ID</span>
              <div class="item-content">{{ forms.taskNo }}</div>
            </div>

            <!-- 选择时间 -->
            <div class="item select-time">
              <span class="item-title">选择时间</span>
              <div class="item-content">
                <el-date-picker
                  v-model="forms.timeRange"
                  type="daterange"
                  range-separator="到"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </div>
            </div>

            <!-- 已选车辆 -->
            <div class="item select-vehicle">
              <span class="item-title">已选车辆</span>
              <div class="item-content">
                <el-tag
                  :key="tag.id"
                  v-for="tag in dynamicTags"
                  closable
                  :disable-transitions="false"
                  @close="handleCloseTag(tag.id)"
                >
                  {{ tag.label }}
                </el-tag>
              </div>
            </div>

            <!-- 区域 -->
            <div class="item select-area">
              <span class="item-title">已选区域</span>
              <div class="item-content">
                <el-tag
                  :key="tag.id"
                  v-for="tag in dynamicAreaTags"
                  closable
                  :disable-transitions="false"
                  @close="handleAreaCloseTag(tag.id)"
                >
                  {{ tag.label }}
                </el-tag>
              </div>
            </div>
          </div>

          <!-- 中间区域 -->
          <div class="wrapper-middle">
            <!-- 标题 -->
            <div class="vehicle-title">选择车辆</div>
            <!-- 车辆查询 -->
            <div class="vehicle-search">
              <div class="vehicle-search_left">
                <span class="text">已选择车辆：</span>
                <span class="num">{{ dynamicTags.length }}</span>
                <span class="clear" @click="handleClear()">清空选择</span>
              </div>
              <div class="vehicle-search_right">
                <el-input
                  class="search-input"
                  clearable
                  placeholder="公司名称/车牌号"
                  v-model="filterOrganization"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click="handleFilterOrganization"
                  ></el-button>
                </el-input>
              </div>
            </div>

            <!-- 操作车辆 -->
            <div
              class="vehicle-operate"
              v-loading="vehicleTreeLoding"
              element-loading-text="数据加载中"
            >
              <el-tree
                ref="tree"
                :data="vehicleList"
                show-checkbox
                default-expand-all
                :check-strictly="true"
                :highlight-current="true"
                node-key="id"
                @check="handleCheck"
                :props="defaultProps"
                :filter-node-method="filterNode"
              >
              </el-tree>
            </div>
          </div>

          <!-- 右侧区域 -->
          <div class="wrapper-right">
            <!-- 标题 -->
            <div class="vehicle-title">选择区域</div>

            <!-- 车辆查询 -->
            <div class="vehicle-search">
              <div class="vehicle-search_left">
                <span class="text">已选择区域：</span>
                <span class="num">{{ dynamicAreaTags.length }}</span>
                <span class="clear" @click="handleAreaClear()">清空选择</span>
              </div>
              <div class="vehicle-search_right">
                <el-input
                  class="search-input"
                  clearable
                  placeholder="区域名称"
                  v-model="filterAreaOrganization"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click="handleAreaFilterOrganization"
                  ></el-button>
                </el-input>
              </div>
            </div>

            <!-- 操作区域 -->
            <div
              class="vehicle-operate"
              v-loading="areaTreeLoding"
              element-loading-text="数据加载中"
            >
              <el-tree
                ref="areaTree"
                :data="areaList"
                show-checkbox
                default-expand-all
                :check-strictly="true"
                :highlight-current="true"
                node-key="id"
                @check="handleAreaCheck"
                :props="defaultProps"
                :filter-node-method="filterAreaNode"
              >
              </el-tree>
            </div>
          </div>
        </div>

        <!-- 按钮操作 start -->
        <div class="operate-section">
          <el-button class="save" :loading="saveLoading" @click="handleSave()">保存</el-button>
          <button
            class="cancel"
            @click="$router.push('inOutAreaAnalyzeExportList')"
          >
            取消
          </button>
        </div>
        <!-- 按钮操作 end -->
      </div>
      <!-- 内容部分 end -->
    </div>
  </div>
</template>

<script>
import {
  getTaskNo,
  getVehicleInfoTree,
  saveExportInOutAreaTask,
  getAreaDataTree
} from "@/api/systemSetting/inOutAreaAnalyzeExport";

import moment from "moment";
import cloneDeep from "lodash/cloneDeep";

export default {
  data() {
    return {
      vehicleTreeLoding: false, // 车辆树 loding
      areaTreeLoding: false, // 区域树Loding
      forms: {
        taskNo: "",
        timeRange: [
          moment()
            .subtract(1, "months")
            .format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD HH:mm:ss")
        ],
        bTime: "",
        eTime: "",
        vehicleIdList: [],
        areaId: ""
      },
      dynamicTags: [], // 车辆选择tag
      dynamicAreaTags: [], // 区域选择tag
      vehicleList: [], // 车辆下拉list
      areaList: [], // 区域List
      defaultProps: {
        children: "children",
        label: "label"
      },
      filterOrganization: "", // 车辆筛选值
      filterAreaOrganization: "" ,// 车辆筛选值
        saveLoading:false
    };
  },

  watch: {
    // 监听用户输入车辆内容
    filterOrganization(val) {
      if (this.filterOrganization === "") {
        this.$refs.tree.filter(val);
      }
    },

    // 监听用户输入区域内容
    filterAreaOrganization(val) {
      if (this.filterAreaOrganization === "") {
        this.$refs.areaTree.filter(val);
      }
    }
  },
  created() {
    this.getTaskNo(); // 获取任务id
    this.getVehicleList(); // 获取车辆下拉树
    this.getAreaList(); // 获取车辆下拉树
  },
  methods: {
    // 获取任务id
    async getTaskNo() {
      let res = await getTaskNo();
      if (res.code === 1 && res.result) {
        this.forms.taskNo = res.result;
      }
    },

    // 获取 车辆下拉树
    async getVehicleList() {
      try {
        this.vehicleTreeLoding = true;
        let res = await getVehicleInfoTree();
        if (res && res.code === 1) {
          if (res.result && Array.isArray(res.result)) {
            this.vehicleList = res.result;
          }
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.vehicleTreeLoding = false;
      }
    },

    // 获取 区域下拉树
    async getAreaList() {
      try {
        this.areaTreeLoding = true;
        let res = await getAreaDataTree();
        if (res && res.code === 1) {
          if (res.result && Array.isArray(res.result)) {
            this.areaList = res.result;
          }
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.areaTreeLoding = false;
      }
    },

    // 选择车辆
    handleCheck(item, node) {
      let newAry = [];
      node.checkedNodes.forEach(item => {
        if (!item.children) {
          newAry.push(item);
        }
      });
      this.dynamicTags = newAry;
    },

    // 选择区域
    handleAreaCheck(data) {
      this.$refs.areaTree.setCheckedNodes([data]);
      this.dynamicAreaTags = [data];
    },

    // 过滤部门方法
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },

    // 过滤部门
    handleFilterOrganization() {
      this.$refs.tree.filter(this.filterOrganization);
    },

    // 过滤区域方法
    filterAreaNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },

    // 过滤区域
    handleAreaFilterOrganization() {
      this.$refs.areaTree.filter(this.filterAreaOrganization);
    },

    // 清空车辆选择
    handleClear() {
      if (!this.dynamicTags.length) {
        this.$message.warning("未选择任何车辆");
        return;
      }
      this.$confirm("确认清空已选择车辆", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$refs.tree.setCheckedKeys([]);
          this.dynamicTags = [];
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    // 清空区域
    handleAreaClear() {
      if (!this.dynamicAreaTags.length) {
        this.$message.warning("未选择任何区域");
        return;
      }
      this.$confirm("确认清空已选择区域", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$refs.areaTree.setCheckedKeys([]);
          this.dynamicAreaTags = [];
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    // 取消已选车辆tag
    handleCloseTag(id) {
      this.dynamicTags.splice(
        this.dynamicTags.findIndex(item => {
          return item.id === id;
        }),
        1
      );
      this.$refs.tree.setCheckedNodes(this.dynamicTags);
    },
    // 取消已选区域tag
    handleAreaCloseTag(id) {
      this.dynamicAreaTags.splice(
        this.dynamicAreaTags.findIndex(item => {
          return item.id === id;
        }),
        1
      );
      this.$refs.areaTree.setCheckedNodes(this.dynamicAreaTags);
    },

    // 保存提交
    handleSave() {
      if (!this.dynamicTags.length) {
        this.$message.warning("未选择任何车辆");
        return;
      }

      if (!this.dynamicAreaTags.length) {
        this.$message.warning("未选择任何区域");
        return;
      }

      let start = moment(this.forms.timeRange[0]);
      let end = moment(this.forms.timeRange[1]);
      if (end.diff(start, "days") > 30) {
        this.$message.warning("开始时间与结束时间间隔不能大于31天");
        return;
      }

      let params = cloneDeep(this.forms);
      params.vehicleIdList = this.dynamicTags.map(item => item.id);
      params.areaId = this.dynamicAreaTags[0].id || "";
      params.bTime = start.format("YYYY-MM-DD");
      params.eTime = end.format("YYYY-MM-DD");
      delete params.timeRange;
      this.handleSumbit(params);
    },

    async handleSumbit(params) {
        this.saveLoading = true;
      let res = await saveExportInOutAreaTask(params);
      if (res && res.code === 1) {
        this.$message.success(res.message);
        this.$router.push("inOutAreaAnalyzeExportList");
      }else{
          this.saveLoading = false;
          this.$message.error(res.message);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
  .section-wrapper {
    height: 100%;
    // 标题
    .content-title {
      padding: 15px;
      color: #333;
      font-size: 16px;
    }

    //内容部分
    .content-section {
      height: calc(100% - 50px - 20px);
      padding: 20px 20px 0;
      border: 1px solid #e6e6e6;
      border-radius: 3px;
      margin: 0 20px 20px;
      box-sizing: border-box;
      // 展示选择车辆区域
      .wrapper {
        display: flex;
        flex-direction: row;
        height: calc(100% - 60px);
        overflow: auto;

        &-left,
        &-middle,
        &-right {
          border: 2px solid #eae5e5;
          border-radius: 5px;
        }

        // 左侧区域
        &-left {
          margin-right: 15px;
          flex: 1.7;

          .item {
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 20px 20px 0;

            // 标题
            &-title {
              width: 65px;
              font-size: 16px;
              text-align: right;
            }

            // 内容
            &-content {
              width: calc(100% - 80px);
              margin-left: 20px;
            }
          }

          // 已选车辆
          .select-vehicle {
            height: calc(100% - 38px - 88px - 120px);

            .item-title,
            .item-content {
              height: 100%;
            }

            // 内容区块
            /deep/ .item-content {
              box-shadow: 0 0 5px 2px #bcbcbc;
              border-radius: 5px;
              overflow: auto;

              .el-tag--mini {
                height: 28px;
                padding: 0 10px;
                line-height: 28px;
                width: 50%;
              }

              .el-tag {
                font-size: 14px;
                background-color: transparent;
                border-color: transparent;
                .el-icon-close {
                  font-size: 16px;
                  top: 1px;
                }
              }
            }
          }

          // 已选区域
          .select-area {
            height: 100px;
            padding-bottom: 20px;

            .item-title,
            .item-content {
              height: 100%;
            }

            // 内容区块
            /deep/ .item-content {
              box-shadow: 0 0 5px 2px #bcbcbc;
              border-radius: 5px;
              overflow: auto;

              .el-tag--mini {
                height: 28px;
                padding: 0 10px;
                line-height: 28px;
                width: 50%;
              }

              .el-tag {
                font-size: 14px;
                background-color: transparent;
                border-color: transparent;
                .el-icon-close {
                  font-size: 16px;
                  top: 1px;
                }
              }
            }
          }
        }

        // 中间区域
        &-middle {
          flex: 1.2;
          min-width: 450px;
          margin-left: 15px;

          .vehicle {
            // 标题
            &-title {
              font-size: 14px;
              text-align: center;
              color: #333;
              background-color: #f2f2f2;
              padding: 15px 0;
            }

            // 搜索查询区域
            &-search {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              padding: 15px;
              border-bottom: 1px solid #eeeeee;

              &_left {
                display: flex;
                flex-direction: row;
                align-items: center;

                // 已选车辆
                .text {
                  color: #aeaeae;
                }

                // 选择车辆数
                .num {
                  display: block;
                  width: 22px;
                  height: 22px;
                  line-height: 22px;
                  font-size: 13px;
                  text-align: center;
                  color: #fff;
                  background-color: rgba(3, 169, 244, 0.45);
                  border-radius: 50%;
                  margin-left: 4px;
                }

                // 清空选择
                .clear {
                  color: rgba(3, 169, 244, 0.5);
                  cursor: pointer;
                  margin-left: 7px;
                }
              }
            }

            // 车辆操作选择
            &-operate {
              height: calc(100% - 46px - 59px - 40px);
              padding: 20px;
              overflow: auto;
            }
          }
        }

        &-right {
          flex: 1;
          min-width: 450px;
          margin-left: 15px;

          .vehicle {
            // 标题
            &-title {
              font-size: 14px;
              text-align: center;
              color: #333;
              background-color: #f2f2f2;
              padding: 15px 0;
            }

            // 搜索查询区域
            &-search {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              padding: 15px;
              border-bottom: 1px solid #eeeeee;

              &_left {
                display: flex;
                flex-direction: row;
                align-items: center;

                // 已选车辆
                .text {
                  color: #aeaeae;
                }

                // 选择车辆数
                .num {
                  display: block;
                  width: 22px;
                  height: 22px;
                  line-height: 22px;
                  font-size: 13px;
                  text-align: center;
                  color: #fff;
                  background-color: rgba(3, 169, 244, 0.45);
                  border-radius: 50%;
                  margin-left: 4px;
                }

                // 清空选择
                .clear {
                  color: rgba(3, 169, 244, 0.5);
                  cursor: pointer;
                  margin-left: 7px;
                }
              }
            }

            // 车辆操作选择
            &-operate {
              height: calc(100% - 46px - 59px - 40px);
              padding: 20px;
              overflow: auto;
            }
          }
        }
      }

      // 底部按钮操作部分
      .operate-section {
        height: 60px;
        line-height: 60px;
        text-align: center;

        // 按钮
        & > button {
          width: 78px;
          height: 30px;
          //line-height: 30px;
          border: none;
          border-radius: 3px;
          margin: 0 25px;
          font-size: 14px;
          cursor: pointer;
          outline-color: transparent;
          // 点击
          &:active {
            transition: all 0.5s;
            transform: scale(0.95);
          }

          // 鼠标移入
          &:hover {
            opacity: 0.95;
          }

          // 保存
          &.save {
            color: #fff;
            background-color: #5d70d6;
          }

          // 取消
          &.cancel {
            color: #5d70d6;
            background-color: #dfe2ee;
          }
        }
      }
    }
  }
}
</style>
